import { render, staticRenderFns } from "./witnessDetail.vue?vue&type=template&id=4b7f3c2c&scoped=true&"
import script from "./witnessDetail.vue?vue&type=script&lang=js&"
export * from "./witnessDetail.vue?vue&type=script&lang=js&"
import style0 from "./witnessDetail.vue?vue&type=style&index=0&id=4b7f3c2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7f3c2c",
  null
  
)

export default component.exports